export const API = window.apigClientFactory.newClient()
export const ENDPOINT = "https://yeddnax2q8.execute-api.eu-west-2.amazonaws.com/prod"
